/* eslint-disable */
const namespace = 'ideaManage';
const GETSAFEIDEALIST = `${namespace}getSafeIdeaList`; // 获取安全策略list
const GETSINGLEIDEA = `${namespace}getSingelIdea`; // 获取安全策略list
export { GETSAFEIDEALIST, GETSINGLEIDEA };
